export default "/_nuxt/6bcf1c04575732b042cda46b44ba1d9e.svg";